/* unplugin-vue-components disabled */import script from "./AccountFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountFeature.vue?vue&type=script&setup=true&lang=js"

import "./AccountFeature.vue?vue&type=style&index=0&id=f2de11d2&lang=scss"

const __exports__ = script;

export default __exports__